module.exports = __webpack_public_path__ + "static/img/arrow-right-red.6c122959.svg";